import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { conversationalSettingsCacheKeys } from "./constants";
import type { ConversationalSettingsResult, PutConversationalSettingsProps } from "./types";

export const putConversationalSettings = reactQueryMutationAdapter(
  conversationalSettingsCacheKeys,
  (props: PutConversationalSettingsProps): Promise<ConversationalSettingsResult> => {
    return fetch(`/${props.appGroupId}/conversational/settings`, "PUT", {
      brand_guideline_id: props.brandGuidelineId,
      opening_message: props.openingMessage,
      handoff_guidance: props.handoffGuidance,
      ai_disclosure_message: props.aiDisclosureMessage,
      chat_max_turns_per_user_per_channel_scope_per_day: props.chatMaxTurnsPerUserPerChannelScopePerDay,
    });
  }
);
